// Helpers for the header bell. The feed itself is built by GET /api/notifications/feed.

/** React Query key for the feed. */
export const FEED_KEY = ['notification-feed'];

/** Socket events that mean "something new may need the agent's attention". */
export const FEED_SOCKET_EVENTS = [
  'sync:requested', 'sync:completed', 'sync:rejected', 'sync:pending_count_updated',
  'team:agent-registered', 'supervisor:agent_disconnected', 'team:pending_count_updated', 'message:new',
];

/**
 * @param {number} n Unread count.
 * @returns {string} Badge text ("" for none, "9+" past nine).
 */
export const badgeText = (n) => (n > 0 ? (n > 9 ? '9+' : String(n)) : '');

/** @type {Record<string, string>} Tone class per notification type. */
const TONES = {
  sync_request: 'bg-amber-500/20 text-amber-300',
  sync_done: 'bg-emerald-500/20 text-emerald-300',
  sync_declined: 'bg-rose-500/20 text-rose-300',
  sync_cancelled: 'bg-white/10 text-white/60',
  teammate_approval: 'bg-amber-500/20 text-amber-300',
  unread_texts: 'bg-sky-500/20 text-sky-300',
  lead_assignment: 'bg-civix-purple/20 text-civix-purpleSoft',
  duplicate_lead: 'bg-amber-500/20 text-amber-300',
  supervisor_disconnect: 'bg-rose-500/20 text-rose-300',
};

/**
 * @param {string} type
 * @returns {string} Tailwind classes for the item's icon chip.
 */
export const toneFor = (type) => TONES[type] || 'bg-civix-purple/20 text-civix-purpleSoft';
